import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgClose = (props) => (
  <SvgIcon {...props} title="Close">
    <svg
      viewBox="0 0 12 12"
      fill="#000"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.25.758a.83.83 0 0 0-1.175 0L6 4.825 1.925.75A.83.83 0 1 0 .75 1.925L4.825 6 .75 10.075a.83.83 0 1 0 1.175 1.175L6 7.175l4.075 4.075a.83.83 0 1 0 1.175-1.175L7.175 6l4.075-4.075a.835.835 0 0 0 0-1.167Z"
        fill={props.fill}
      />
    </svg>
  </SvgIcon>
);

export default SvgClose;
